export { default as AcquisitionDesktopHeader } from './desktop-header/desktop-header.component';
export { default as FAQs } from './faqs/faqs.component';
export { default as HowItWorksSection } from './how-it-works-section/how-it-works-section.component';
export { default as Banner } from './mobile-banner/mobile-banner.component';
export { default as SellCarForm } from './sell-car-form/sell-form-mobile.component';
export { default as TestimonialSection } from './testimonial/testimonial-section/testimonial-section.component';
export { default as WhySellYourCarSection } from './why-sell-your-car-section/why-sell-your-car-section.component';
export { default as AcquisitionPage } from './acquisition.page';
export { default as NewTestimonialSection } from './newTestimonial/testimonial-section/testimonial-section.component';
export { default as TestimonialVids } from '../testimonialVidSlider/testimonial-vids.component';
